const fetchTasks = async(params) => {
  params = { ...params }
  
  try {
    return await axios.get('/tasks', {
      params,
    })
  } catch (e) {
    throw e
  }
}

const fetchTask = async(params) => {
  try {
    return await axios.get(`/task/${params.id}`, {
      params: {
        ...params.query,
      },
    })
  } catch (e) {
    throw e
  }
}

const fetchClassifications = async() => {
  try {
    return await axios.get(`/tasks/classifications`)
  } catch (e) {
    throw e
  }
}

const markTaskAsComplete = async({ task }) => {
  try {
    return await axios.post(`/tasks/${ task.id }/complete`)
  } catch (e) {
    throw e
  }
}

export {
  fetchTasks,
  fetchTask,
	fetchClassifications,
  markTaskAsComplete,
}
